import styled from 'styled-components';

export const ContentEditorWrapper = styled.div`
  /* ... (otros estilos se mantienen igual) */

  /* Nuevos estilos para los toggle switches independientes */
  .instagram-toggle-group {
    display: flex;
    flex-direction: row;
    gap: 15px;
    margin: 20px 0;
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
  }

  .instagram-toggle-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .instagram-toggle-label {
    font-size: 14px;
    font-weight: 500;
    color: #495057;
    margin-right: 15px;
  }

  .instagram-toggle-switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 24px;
  }

  .instagram-toggle-switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .instagram-toggle-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 24px;
  }

  .instagram-toggle-slider:before {
    position: absolute;
    content: '';
    height: 16px;
    width: 16px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }

  input:checked + .instagram-toggle-slider {
    background: linear-gradient(136deg, #770cab, #b721ff);
  }

  input:checked + .instagram-toggle-slider:before {
    transform: translateX(26px);
  }

  /* Campos de video */
  .video-fields {
    /* ... (mantener estilos existentes) */
  }
`;

export const TextPlain = styled.div`
  text-align: left;

  p {
    text-align: justify;
    font-weight: 500;
    line-height: 1.5;
    font-size: 14px;
    color: #495057;
  }

  button {
    margin-top: 20px;
    width: 100%;
    transition: all 0.3s ease;
  }

  .programmerButton {
    background: #b721ff;
    border: 1px solid #b721ff;
    background-image: linear-gradient(136deg, #770cab, #b721ff);
    color: white;

    &:hover {
      opacity: 0.9;
      transform: translateY(-1px);
      box-shadow: 0 4px 8px rgba(183, 33, 255, 0.3);
    }
  }

  .rejectParticipation {
    width: 100%;
    text-align: center;
    margin-top: 2%;

    span {
      cursor: pointer;
      color: #05559c;
      font-size: 14px;
      font-weight: 500;
      transition: all 0.3s ease;
      display: inline-flex;
      align-items: center;

      &:hover {
        color: #03396c;
        text-decoration: underline;

        &::after {
          content: '→';
          margin-left: 4px;
          transition: all 0.3s ease;
        }
      }
    }
  }
`;
